import React from "react";
import {
  FormHelperText,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";

export const CurrencyPicker = ({
  name,
  value,
  onChange,
  errorTrue,
  errorText,
  disabledTrue,
}) => {
  return (
    <React.Fragment>
      <FormControl
        variant="outlined"
        fullWidth
        error={errorTrue ? true : false}
        disabled={disabledTrue ? true : false}
      >
        <InputLabel id="demo-simple-select-outlined-label">Currency</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          name={name}
          value={value}
          onChange={onChange}
          label="Currency"
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          <MenuItem value="USD" selected="selected">
            United States Dollars
          </MenuItem>
          <MenuItem value="GBP">United Kingdom Pounds</MenuItem>
          <MenuItem value="DZD">Algeria Dinars</MenuItem>
          <MenuItem value="ARP">Argentina Pesos</MenuItem>
          <MenuItem value="AUD">Australia Dollars</MenuItem>
          <MenuItem value="ATS">Austria Schillings</MenuItem>
          <MenuItem value="BSD">Bahamas Dollars</MenuItem>
          <MenuItem value="BBD">Barbados Dollars</MenuItem>
          <MenuItem value="BEF">Belgium Francs</MenuItem>
          <MenuItem value="BMD">Bermuda Dollars</MenuItem>
          <MenuItem value="BRR">Brazil Real</MenuItem>
          <MenuItem value="BGL">Bulgaria Lev</MenuItem>
          <MenuItem value="CAD">Canada Dollars</MenuItem>
          <MenuItem value="CLP">Chile Pesos</MenuItem>
          <MenuItem value="CNY">China Yuan Renmimbi</MenuItem>
          <MenuItem value="CYP">Cyprus Pounds</MenuItem>
          <MenuItem value="CSK">Czech Republic Koruna</MenuItem>
          <MenuItem value="DKK">Denmark Kroner</MenuItem>
          <MenuItem value="NLG">Dutch Guilders</MenuItem>
          <MenuItem value="EGP">Egypt Pounds</MenuItem>
          <MenuItem value="FJD">Fiji Dollars</MenuItem>
          <MenuItem value="FIM">Finland Markka</MenuItem>
          <MenuItem value="FRF">France Francs</MenuItem>
          <MenuItem value="DEM">Germany Deutsche Marks</MenuItem>
          <MenuItem value="GRD">Greece Drachmas</MenuItem>
          <MenuItem value="HKD">Hong Kong Dollars</MenuItem>
          <MenuItem value="HUF">Hungary Forint</MenuItem>
          <MenuItem value="ISK">Iceland Krona</MenuItem>
          <MenuItem value="INR">India Rupees</MenuItem>
          <MenuItem value="IDR">Indonesia Rupiah</MenuItem>
          <MenuItem value="IEP">Ireland Punt</MenuItem>
          <MenuItem value="ILS">Israel New Shekels</MenuItem>
          <MenuItem value="ITL">Italy Lira</MenuItem>
          <MenuItem value="JMD">Jamaica Dollars</MenuItem>
          <MenuItem value="JPY">Japan Yen</MenuItem>
          <MenuItem value="JOD">Jordan Dinar</MenuItem>
          <MenuItem value="LBP">Lebanon Pounds</MenuItem>
          <MenuItem value="LUF">Luxembourg Francs</MenuItem>
          <MenuItem value="MYR">Malaysia Ringgit</MenuItem>
          <MenuItem value="MXP">Mexico Pesos</MenuItem>
          <MenuItem value="NLG">Netherlands Guilders</MenuItem>
          <MenuItem value="NZD">New Zealand Dollars</MenuItem>
          <MenuItem value="NOK">Norway Kroner</MenuItem>
          <MenuItem value="PKR">Pakistan Rupees</MenuItem>
          <MenuItem value="XPD">Palladium Ounces</MenuItem>
          <MenuItem value="PHP">Philippines Pesos</MenuItem>
          <MenuItem value="XPT">Platinum Ounces</MenuItem>
          <MenuItem value="PLZ">Poland Zloty</MenuItem>
          <MenuItem value="PTE">Portugal Escudo</MenuItem>
          <MenuItem value="ROL">Romania Leu</MenuItem>
          <MenuItem value="RUR">Russia Rubles</MenuItem>
          <MenuItem value="SAR">Saudi Arabia Riyal</MenuItem>
          <MenuItem value="SGD">Singapore Dollars</MenuItem>
          <MenuItem value="SKK">Slovakia Koruna</MenuItem>
          <MenuItem value="ZAR">South Africa Rand</MenuItem>
          <MenuItem value="KRW">South Korea Won</MenuItem>
          <MenuItem value="ESP">Spain Pesetas</MenuItem>
          <MenuItem value="XDR">Special Drawing Right (IMF)</MenuItem>
          <MenuItem value="SDD">Sudan Dinar</MenuItem>
          <MenuItem value="SEK">Sweden Krona</MenuItem>
          <MenuItem value="CHF">Switzerland Francs</MenuItem>
          <MenuItem value="TWD">Taiwan Dollars</MenuItem>
          <MenuItem value="THB">Thailand Baht</MenuItem>
          <MenuItem value="TTD">Trinidad and Tobago Dollars</MenuItem>
          <MenuItem value="TRL">Turkey Lira</MenuItem>
          <MenuItem value="VEB">Venezuela Bolivar</MenuItem>
          <MenuItem value="ZMK">Zambia Kwacha</MenuItem>
          <MenuItem value="EUR">Euro</MenuItem>
          <MenuItem value="XCD">Eastern Caribbean Dollars</MenuItem>
          <MenuItem value="XAG">Silver Ounces</MenuItem>
          <MenuItem value="XAU">Gold Ounces</MenuItem>
        </Select>
        <FormHelperText>{errorText}</FormHelperText>
      </FormControl>
    </React.Fragment>
  );
};
